// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app #verify-tree-grid .main-inner-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#app #verify-tree-grid .query-input-spacing {\n  padding-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
